import { BaseWorkflowStep } from "./BaseWorkflowStep";

abstract class AutomaticWorkflowStep<T> extends BaseWorkflowStep<T> {
    public constructor(stepEnum: T) {
        super(stepEnum);
    }

    public abstract execute(): void;
}

export { AutomaticWorkflowStep };
